(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-header-topbar"]) return;
  try {
    
(function () {
  const BREAKPOINT = 991;
  let swiper = null;

  function initSwiper() {
    if (swiper) return;
    swiper = new Swiper('.topbar__usps', {
      direction: 'horizontal',
      loop: true,
      autoplay: { delay: 2000, disableOnInteraction: false },
      slidesPerView: 1,
    });
  }

  function destroySwiper() {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
  }

  function applyMode() {
    const isMobile = window.innerWidth < BREAKPOINT;
    const usps = document.querySelector('.topbar__usps');
    if (!usps) return;
    if (isMobile) initSwiper();
    else destroySwiper();
  }

  applyMode();
  let to = null;
  window.addEventListener('resize', () => {
    clearTimeout(to);
    to = setTimeout(applyMode, 100);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
